<template>
  <div class="h-100">
    <div v-show="toogleViwer" class="h-100">
      <div class="row align-items-center">
        <div class="col-6">
          <VueMultiselect v-show="options.videoOptions.src != ''" v-model="accnamein" tag-placeholder="Add this as new Account" style="width:100%"
            placeholder="Select Chapter" label="name" track-by="name" :options="myVal" :multiple="false"
            :close-on-select="true" @select="getTime" selectLabel="">
            <template v-slot:option="{ option }">
              {{ new Date(option.time * 1000).toISOString().slice(11, 19) }} - <b>{{ option.name }}</b>
            </template>
          </VueMultiselect>
        </div>
        <div class="col-6">
          <a v-on:click="toogleViwer = !toogleViwer" class="nonEffect w-100 my-2" style="padding: 4px 8px;">{{ title }} in
            user guide</a>
        </div>
      </div>
      <div  v-show="options.videoOptions.src != ''">
        <div class="container">
          <div class="video-container" id="video-container">
            <div class="playback-animation" id="playback-animation">
              <svg class="playback-icons">
                <use class="hidden" href="#play-icon"></use>
                <use href="#pause"></use>
              </svg>
            </div>
            <video controls disablepictureinpicture class="video" id="video" preload="metadata" ref="videoPlayer"
              :poster="require(`../../assets/images/track/${options.videoOptions.img}`)">
              <source :src="options.videoOptions.src" type="video/mp4" />
            </video>
            <div class="video-controls hidden" id="video-controls">
              <div class="video-progress">
                <span><progress id="progress-bar" value="0" min="0"></progress></span>
                <div id="progress-bar1" value="0" min="0">
                  <span v-for="myTimeSection in myTimeSections" v-bind:key="myTimeSection" :title="myTimeSection.title"
                    :style="'width: ' + myTimeSection.width + '%'" style="margin-left: 0.2%">
                  </span>
                </div>
                <input class="seek" id="seek" value="0" min="0" type="range" step="1">
                <div class="seek-tooltip" id="seek-tooltip">00:00</div>
              </div>
              <div class="bottom-controls">
                <div class="left-controls">
                  <button data-title="Play (k)" id="play">
                    <svg class="playback-icons">
                      <use href="#play-icon"></use>
                      <use class="hidden" href="#pause"></use>
                    </svg>
                  </button>
                  <div class="volume-controls">
                    <button data-title="Mute (m)" class="volume-button" id="volume-button">
                      <svg>
                        <use class="hidden" href="#volume-mute"></use>
                        <use class="hidden" href="#volume-low"></use>
                        <use href="#volume-high"></use>
                      </svg>
                    </button>
                    <input class="volume" id="volume" value="1" data-mute="0.5" type="range" max="1" min="0" step="0.01">
                  </div>
                  <div class="time">
                    <time id="time-elapsed">00:00</time>
                    <span> / </span>
                    <time id="duration">00:00</time>
                  </div>
                </div>
                <div class="right-controls">
                  <button data-title="PIP (p)" class="pip-button" id="pip-button">
                    <svg>
                      <use href="#pip"></use>
                    </svg>
                  </button>
                  <button data-title="Full screen (f)" class="fullscreen-button" id="fullscreen-button">
                    <svg>
                      <use href="#fullscreen"></use>
                      <use href="#fullscreen-exit" class="hidden"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <svg style="display: none">
          <defs>
            <symbol id="pause" viewBox="0 0 24 24">
              <path d="M14.016 5.016h3.984v13.969h-3.984v-13.969zM6 18.984v-13.969h3.984v13.969h-3.984z"></path>
            </symbol>
            <symbol id="play-icon" viewBox="0 0 24 24">
              <path d="M8.016 5.016l10.969 6.984-10.969 6.984v-13.969z"></path>
            </symbol>
            <symbol id="volume-high" viewBox="0 0 24 24">
              <path
                d="M14.016 3.234q3.047 0.656 5.016 3.117t1.969 5.648-1.969 5.648-5.016 3.117v-2.063q2.203-0.656 3.586-2.484t1.383-4.219-1.383-4.219-3.586-2.484v-2.063zM16.5 12q0 2.813-2.484 4.031v-8.063q1.031 0.516 1.758 1.688t0.727 2.344zM3 9h3.984l5.016-5.016v16.031l-5.016-5.016h-3.984v-6z">
              </path>
            </symbol>
            <symbol id="volume-low" viewBox="0 0 24 24">
              <path
                d="M5.016 9h3.984l5.016-5.016v16.031l-5.016-5.016h-3.984v-6zM18.516 12q0 2.766-2.531 4.031v-8.063q1.031 0.516 1.781 1.711t0.75 2.32z">
              </path>
            </symbol>
            <symbol id="volume-mute" viewBox="0 0 24 24">
              <path
                d="M12 3.984v4.219l-2.109-2.109zM4.266 3l16.734 16.734-1.266 1.266-2.063-2.063q-1.547 1.313-3.656 1.828v-2.063q1.172-0.328 2.25-1.172l-4.266-4.266v6.75l-5.016-5.016h-3.984v-6h4.734l-4.734-4.734zM18.984 12q0-2.391-1.383-4.219t-3.586-2.484v-2.063q3.047 0.656 5.016 3.117t1.969 5.648q0 2.203-1.031 4.172l-1.5-1.547q0.516-1.266 0.516-2.625zM16.5 12q0 0.422-0.047 0.609l-2.438-2.438v-2.203q1.031 0.516 1.758 1.688t0.727 2.344z">
              </path>
            </symbol>
            <symbol id="fullscreen" viewBox="0 0 24 24">
              <path
                d="M14.016 5.016h4.969v4.969h-1.969v-3h-3v-1.969zM17.016 17.016v-3h1.969v4.969h-4.969v-1.969h3zM5.016 9.984v-4.969h4.969v1.969h-3v3h-1.969zM6.984 14.016v3h3v1.969h-4.969v-4.969h1.969z">
              </path>
            </symbol>
            <symbol id="fullscreen-exit" viewBox="0 0 24 24">
              <path
                d="M15.984 8.016h3v1.969h-4.969v-4.969h1.969v3zM14.016 18.984v-4.969h4.969v1.969h-3v3h-1.969zM8.016 8.016v-3h1.969v4.969h-4.969v-1.969h3zM5.016 15.984v-1.969h4.969v4.969h-1.969v-3h-3z">
              </path>
            </symbol>
            <symbol id="pip" viewBox="0 0 24 24">
              <path
                d="M21 19.031v-14.063h-18v14.063h18zM23.016 18.984q0 0.797-0.609 1.406t-1.406 0.609h-18q-0.797 0-1.406-0.609t-0.609-1.406v-14.016q0-0.797 0.609-1.383t1.406-0.586h18q0.797 0 1.406 0.586t0.609 1.383v14.016zM18.984 11.016v6h-7.969v-6h7.969z">
              </path>
            </symbol>
          </defs>
        </svg>
      </div>
      <div v-show="options.videoOptions.src == ''" class="h-100 w-100">
        <div class="d-flex align-items-center justify-content-center h-100">
          video not available yet. Please refer user guide pdf.

        </div>
      </div>
    </div>
    <div v-show="!toogleViwer" class="position-relative h-100" style="overflow: auto;">
      <div class="close-container myfaBtn" @click="toogleViwer = !toogleViwer">
        <div class="leftright"></div>
        <div class="rightleft"></div>
      </div>
      <button class="uSpl primary left-btn me-1" :disabled="pageNumber <= 1" @click="pageNumber--">
        <font-awesome-icon icon="fa-solid fa-angle-left" class="btn-icon" /> Prev&nbsp;&nbsp;</button>
      <button class="uSpl primary right-btn ms-1" :disabled="pageNumber >= pageCount"
        @click="pageNumber++">&nbsp;&nbsp;Next
        <font-awesome-icon icon="fa-solid fa-angle-right" class="btn-icon" /></button>
      <div class="pdf-container-video p-3">
        <vue-pdf-embed ref="pdfRefVideo" :source="pdfLink" :page="pageNumber" :scale="scale" @rendered="handleDocumentRender"
          class="h-100" />
      </div>
    </div>
  </div>
</template>
<script>
import VuePdfEmbed from 'vue-pdf-embed';
import pdfLink from "./../../data/OPSight_User_Guide.pdf";
export default {
  name: "App",
  components: {
    VuePdfEmbed,
  },
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      player: null,
      accnamein: null,
      title: "",
      pageNumber: 1,
      myVal: [],
      pageCount: 1,
      pdfLink,
      toogleViewer: true,
      page: 2,
      toogleViwer: true,
      myTimeSections: [],
      mytotalTime: 0,
      scale:1,
    }
  },
  methods: {
    handleDocumentRender() {
      this.pageCount = this.$refs.pdfRefVideo.pageCount
    },
    setCurTime(val) {
      this.$refs.videoPlayer.currentTime = val;
    },
    getTime(selectedOption, id) {
      this.$refs.videoPlayer.currentTime = selectedOption.time;
    },
  },
  mounted() {
    this.myVal = this.options.videoOptions.tracks;
    this.title = this.options.title
    this.pageNumber = this.options.pageNumber
    this.myVal = this.options.videoOptions.tracks;
    this.mytotalTime = 0;
    for (let index = 0; index < this.myVal.length - 1; index++) {
      const element = this.myVal[index];
      this.myTimeSections.push({
        "start": element.time,
        "end": this.myVal[index + 1].time,
        "duration": this.myVal[index + 1].time - element.time,
        "width": (((this.myVal[index + 1].time - element.time) / this.options.videoOptions.time) * 100) - 0.2,
        "title": this.options.videoOptions.tracks[index].name
      })
    }
    this.myTimeSections.push({
      "start": this.myVal[this.myVal.length - 1].time,
      "end": this.options.videoOptions.time,
      "duration": this.options.videoOptions.time - this.myVal[this.myVal.length - 1].time,
      "width": (((this.options.videoOptions.time - this.myVal[this.myVal.length - 1].time) / this.options.videoOptions.time) * 100) - 0.2,
      "title": this.options.videoOptions.tracks[this.myVal.length - 1].name
    })
    var myValVar = this.myTimeSections;
    const videoC = document.getElementById('video-container');
    const video = document.getElementById('video');
    const videoControls = document.getElementById('video-controls');
    const playButton = document.getElementById('play');
    const playbackIcons = document.querySelectorAll('.playback-icons use');
    const timeElapsed = document.getElementById('time-elapsed');
    const duration = document.getElementById('duration');
    const progressBar = document.getElementById('progress-bar');
    const seek = document.getElementById('seek');
    const seekTooltip = document.getElementById('seek-tooltip');
    const volumeButton = document.getElementById('volume-button');
    const volumeIcons = document.querySelectorAll('.volume-button use');
    const volumeMute = document.querySelector('use[href="#volume-mute"]');
    const volumeLow = document.querySelector('use[href="#volume-low"]');
    const volumeHigh = document.querySelector('use[href="#volume-high"]');
    const volume = document.getElementById('volume');
    const playbackAnimation = document.getElementById('playback-animation');
    const fullscreenButton = document.getElementById('fullscreen-button');
    const videoContainer = document.getElementById('video-container');
    const fullscreenIcons = fullscreenButton.querySelectorAll('use');
    const pipButton = document.getElementById('pip-button');
    const videoWorks = !!document.createElement('video').canPlayType;
    if (videoWorks) {
      video.controls = false;
      videoControls.classList.remove('hidden');
    }
    // Add functions here
    // togglePlay toggles the playback state of the video.
    // If the video playback is paused or ended, the video is played
    // otherwise, the video is paused
    function togglePlay() {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    }
    // updatePlayButton updates the playback icon and tooltip
    // depending on the playback state
    function updatePlayButton() {
      playbackIcons.forEach((icon) => icon.classList.toggle('hidden'));
      if (video.paused) {
        playButton.setAttribute('data-title', 'Play (spacebar)');
      } else {
        playButton.setAttribute('data-title', 'Pause (spacebar)');
      }
    }
    // formatTime takes a time length in seconds and returns the time in
    // minutes and seconds
    function formatTime(timeInSeconds) {
      const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8);
      return {
        minutes: result.substr(3, 2),
        seconds: result.substr(6, 2),
      };
    }
    // initializeVideo sets the video duration, and maximum value of the
    // progressBar
    function initializeVideo() {
      const videoDuration = Math.round(video.duration);
      seek.setAttribute('max', videoDuration);
      progressBar.setAttribute('max', videoDuration);
      const time = formatTime(videoDuration);
      duration.innerText = `${time.minutes}:${time.seconds}`;
      duration.setAttribute('datetime', `${time.minutes}m ${time.seconds}s`);
    }
    // updateTimeElapsed indicates how far through the video
    // the current playback is by updating the timeElapsed element
    function updateTimeElapsed() {
      const time = formatTime(Math.round(video.currentTime));
      timeElapsed.innerText = `${time.minutes}:${time.seconds}`;
      timeElapsed.setAttribute('datetime', `${time.minutes}m ${time.seconds}s`);
    }
    // updateProgress indicates how far through the video
    // the current playback is by updating the progress bar
    function updateProgress() {
      seek.value = Math.floor(video.currentTime);
      progressBar.value = Math.floor(video.currentTime);
    }
    // updateSeekTooltip uses the position of the mouse on the progress bar to
    // roughly work out what point in the video the user will skip to if
    // the progress bar is clicked at that point
    function updateSeekTooltip(event) {
      const skipTo = Math.round(
        (event.offsetX / event.target.clientWidth) *
        parseInt(event.target.getAttribute('max'), 10)
      );
      seek.setAttribute('data-seek', skipTo);
      const t = formatTime(skipTo);
      let myTitle = ""
      for (let index = 0; index < myValVar.length; index++) {
        const element = myValVar[index];
        if (skipTo >= element.start && skipTo <= element.end) {
          myTitle = myValVar[index].title
          break;
        }
      }
      // console.log(myValVar)
      seekTooltip.textContent = `${t.minutes}:${t.seconds} - ${myTitle}`;
      const rect = video.getBoundingClientRect();
      seekTooltip.style.left = `${event.pageX - rect.left}px`;
    }
    // skipAhead jumps to a different point in the video when the progress bar
    // is clicked
    function skipAhead(event) {
      const skipTo = event.target.dataset.seek ?
        event.target.dataset.seek :
        event.target.value;
      video.currentTime = skipTo;
      progressBar.value = skipTo;
      seek.value = skipTo;
    }
    // updateVolume updates the video's volume
    // and disables the muted state if active
    function updateVolume() {
      if (video.muted) {
        video.muted = false;
      }
      video.volume = volume.value;
    }
    // updateVolumeIcon updates the volume icon so that it correctly reflects
    // the volume of the video
    function updateVolumeIcon() {
      volumeIcons.forEach((icon) => {
        icon.classList.add('hidden');
      });
      volumeButton.setAttribute('data-title', 'Mute (m)');
      if (video.muted || video.volume === 0) {
        volumeMute.classList.remove('hidden');
        volumeButton.setAttribute('data-title', 'Unmute (m)');
      } else if (video.volume > 0 && video.volume <= 0.5) {
        volumeLow.classList.remove('hidden');
      } else {
        volumeHigh.classList.remove('hidden');
      }
    }
    // toggleMute mutes or unmutes the video when executed
    // When the video is unmuted, the volume is returned to the value
    // it was set to before the video was muted
    function toggleMute() {
      video.muted = !video.muted;
      if (video.muted) {
        volume.setAttribute('data-volume', volume.value);
        volume.value = 0;
      } else {
        volume.value = volume.dataset.volume;
      }
    }
    // animatePlayback displays an animation when
    // the video is played or paused
    function animatePlayback() {
      playbackAnimation.animate(
        [{
          opacity: 1,
          transform: 'scale(1)',
        },
        {
          opacity: 0,
          transform: 'scale(1.3)',
        },
        ], {
        duration: 500,
      }
      );
    }
    // toggleFullScreen toggles the full screen state of the video
    // If the browser is currently in fullscreen mode,
    // then it should exit and vice versa.
    function toggleFullScreen() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else if (document.webkitFullscreenElement) {
        // Need this to support Safari
        document.webkitExitFullscreen();
      } else if (videoContainer.webkitRequestFullscreen) {
        // Need this to support Safari
        videoContainer.webkitRequestFullscreen();
      } else {
        videoContainer.requestFullscreen();
      }
    }
    // updateFullscreenButton changes the icon of the full screen button
    // and tooltip to reflect the current full screen state of the video
    function updateFullscreenButton() {
      fullscreenIcons.forEach((icon) => icon.classList.toggle('hidden'));
      if (document.fullscreenElement) {
        fullscreenButton.setAttribute('data-title', 'Exit full screen (f)');
      } else {
        fullscreenButton.setAttribute('data-title', 'Full screen (f)');
      }
    }
    // togglePip toggles Picture-in-Picture mode on the video
    async function togglePip() {
      try {
        if (video !== document.pictureInPictureElement) {
          pipButton.disabled = true;
          await video.requestPictureInPicture();
        } else {
          await document.exitPictureInPicture();
        }
      } catch (error) {
        console.error(error);
      } finally {
        pipButton.disabled = false;
      }
    }
    // hideControls hides the video controls when not in use
    // if the video is paused, the controls must remain visible
    function hideControls() {
      if (video.paused) {
        return;
      }
      videoControls.classList.add('hide');
    }
    // showControls displays the video controls
    function showControls() {
      videoControls.classList.remove('hide');
    }
    // keyboardShortcuts executes the relevant functions for
    // each supported shortcut key
    function keyboardShortcuts(event) {
      const {
        key
      } = event;
      switch (key) {
        case ' ':
          togglePlay();
          animatePlayback();
          if (video.paused) {
            showControls();
          } else {
            setTimeout(() => {
              hideControls();
            }, 2000);
          }
          break;
        case 'm':
          toggleMute();
          break;
        case 'f':
          toggleFullScreen();
          break;
        case 'p':
          togglePip();
          break;
      }
    }
    // Add eventlisteners here
    playButton.addEventListener('click', togglePlay);
    video.addEventListener('play', updatePlayButton);
    video.addEventListener('pause', updatePlayButton);
    video.addEventListener('loadedmetadata', initializeVideo);
    video.addEventListener('timeupdate', updateTimeElapsed);
    video.addEventListener('timeupdate', updateProgress);
    video.addEventListener('volumechange', updateVolumeIcon);
    video.addEventListener('click', togglePlay);
    video.addEventListener('click', animatePlayback);
    videoC.addEventListener('mouseenter', showControls);
    videoC.addEventListener('mouseleave', hideControls);
    // videoControls.addEventListener('mouseenter', showControls);
    // videoControls.addEventListener('mouseleave', hideControls);
    seek.addEventListener('mousemove', updateSeekTooltip);
    seek.addEventListener('input', skipAhead);
    volume.addEventListener('input', updateVolume);
    volumeButton.addEventListener('click', toggleMute);
    fullscreenButton.addEventListener('click', toggleFullScreen);
    videoContainer.addEventListener('fullscreenchange', updateFullscreenButton);
    pipButton.addEventListener('click', togglePip);
    document.addEventListener('DOMContentLoaded', () => {
      if (!('pictureInPictureEnabled' in document)) {
        pipButton.classList.add('hidden');
      }
    });
    document.addEventListener('keyup', keyboardShortcuts);
  },
};
// Select elements here
</script>
<style scoped>
ul {
  padding-left: 0;
}

:root {
  --youtube-red: #FE0900;
}

.video-container {
  border-radius: 4px;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

video {
  height: 66vh;
  width: 100%;
  border-radius: 4px;
}

.video-controls {
  right: 0;
  left: 0;
  padding: 10px;
  position: absolute;
  bottom: 0;
  transition: all 0.2s ease;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5));
}

.video-controls.hide {
  opacity: 0;
  pointer-events: none;
}

.video-progress {
  position: relative;
  height: 5px;
  margin-bottom: 10px;
}

progress {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 2px;
  width: 100%;
  height: 5px;
  pointer-events: none;
  position: absolute;
  top: 0;
}

progress::-webkit-progress-bar {
  background-color: #474545;
  border-radius: 2px;
}

progress::-webkit-progress-value {
  background: #FE0900;
  border-radius: 2px;
}

progress::-moz-progress-bar {
  border: 1px solid #FE0900;
  background: #FE0900;
}

.seek {
  position: absolute;
  top: 0;
  width: 100%;
  cursor: pointer;
  margin: 0;
}

.seek:hover+.seek-tooltip {
  display: block;
}

.seek-tooltip {
  display: none;
  position: absolute;
  top: -50px;
  margin-left: -20px;
  font-size: 12px;
  padding: 3px;
  content: attr(data-title);
  font-weight: bold;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
}

.bottom-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-controls {
  display: flex;
  align-items: center;
  color: #fff;
}

.volume-controls {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.volume-controls input {
  width: 100px;
  opacity: 1;
  transition: all 0.4s ease;
}

.volume-controls:hover input,
.volume-controls input:focus {
  width: 100px;
  opacity: 1;
}

button {
  cursor: pointer;
  position: relative;
  margin-right: 7px;
  font-size: 12px;
  padding: 3px;
  border: none;
  outline: none;
  background-color: transparent;
}

button * {
  pointer-events: none;
}

button::before {
  content: attr(data-title);
  position: absolute;
  display: none;
  right: 0;
  top: -50px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-weight: bold;
  padding: 4px 6px;
  word-break: keep-all;
  white-space: pre;
}

button:hover::before {
  display: inline-block;
}

.fullscreen-button {
  margin-right: 0;
}

.pip-button svg {
  width: 26px;
  height: 26px;
}

.playback-animation {
  pointer-events: none;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -40px;
  margin-top: -40px;
  width: 80px;
  height: 80px;
  border-radius: 80px;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
}

input[type=range] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 6px;
  background: transparent;
  cursor: pointer;
}

input[type=range]:focus {
  outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  cursor: pointer;
  border-radius: 1.3px;
  -webkit-appearance: none;
  transition: all 0.4s ease;
}

input[type=range]::-webkit-slider-thumb {
  height: 16px;
  width: 16px;
  border-radius: 16px;
  background: #FE0900;
  cursor: pointer;
  -webkit-appearance: none;
  margin-left: -1px;
}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: transparent;
}

input[type=range].volume {
  height: 5px;
  background-color: #fff;
}

input[type=range].volume::-webkit-slider-runnable-track {
  background-color: transparent;
}

input[type=range].volume::-webkit-slider-thumb {
  margin-left: 0;
  height: 14px;
  width: 14px;
  background: #fff;
}

input[type=range]::-moz-range-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  border: 1px solid transparent;
  background: transparent;
  border-radius: 1.3px;
}

input[type=range]::-moz-range-thumb {
  height: 14px;
  width: 14px;
  border-radius: 50px;
  border: 1px solid #FE0900;
  background: #FE0900;
  cursor: pointer;
  margin-top: 5px;
}

input[type=range]:focus::-moz-range-track {
  outline: none;
}

input[type=range].volume::-moz-range-thumb {
  border: 1px solid #fff;
  background: #fff;
}

.hidden {
  display: none;
}

svg {
  width: 28px;
  height: 28px;
  fill: #fff;
  stroke: #fff;
  cursor: pointer;
}

#progress-bar1 {
  height: 3px;
  position: absolute;
  width: 100%;
  top: -13px;
}

#progress-bar1 span {
  background-color: #fff;
  display: inline-block;
  height: 100%;
}

vue-pdf-embed>div {
  position: relative;
  height: 100%;
}

.primary {
  background: transparent;
  border: none;
  margin-bottom: 32px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
}

.primary::before {
  display: none !important;
}

.primary .btn-icon {
  font-size: 12px;
  height: 16px;
}

.primary.left-btn {
  left: 2%;
}

.primary.right-btn {
  right: 2%;
}

.darkTheme .primary {
  color: #fff;
}

button#pip-button {
  display: none;
}</style>